<app-payment-panel-stripe-generic
  type="STRIPE"
  [payButtonText]="'payment.pay-with-credit-card' | translate"
></app-payment-panel-stripe-generic>
